import React from 'react';
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
export default function NavBar(){
  const[activeLink,setactiveLink] = useState('home');
  const [scrolled,seScrolled]=useState(false);

  useEffect(() => {
    const onScroll = () =>{
        if(window.scrollY>100){
            seScrolled(true);
        }else{
            seScrolled(false);
        }

    }

    window.addEventListener("scroll",onScroll);
    return() =>window.removeEventListener("scroll",onScroll);


  },[])

  const onUpdateActiveLink = (value) =>{
    setactiveLink(value);
  }
    
  return (
    <Navbar expand="lg" className={scrolled?"scrolled":""}>
      <Container>
        <a className='navbar-brand' href='#' color='#fff'>
          <img src='https://static.igem.wiki/teams/4298/wiki/white-logo.png'/>
        </a>
        <Navbar.Toggle aria-controls="basic-navbar-nav" >
            <span classname="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className={activeLink ==='home'?'active navbar-link':'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
            <NavDropdown title="Project" id="Project" className={activeLink ==='Project'?'active navbar-link':'navbar-link'} onClick={() => onUpdateActiveLink('Project')}>
              <NavDropdown.Item as={Link} to="/description">Description</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contribution">Contribution</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/implementation">Implementation</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/proof-of-concept">Proof of Concept</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/engineering">Engineering</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/safety">Safety</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Wetlab" id="Wetlab" className={activeLink ==='Wetlab'?'active navbar-link':'navbar-link'}onClick={() => onUpdateActiveLink('Wetlab')}>
              <NavDropdown.Item as={Link} to="/design">Design</NavDropdown.Item>                      
              <NavDropdown.Item as={Link} to="/Parts">Parts</NavDropdown.Item>              
              <NavDropdown.Item as={Link} to="/Notebook">Notebook</NavDropdown.Item>   
              <NavDropdown.Item as={Link} to="/methods">Methods</NavDropdown.Item>         
            </NavDropdown>
            <NavDropdown title="HP" id="HP" className={activeLink ==='HP'?'active navbar-link':'navbar-link'}onClick={() => onUpdateActiveLink('HP')}>
              <NavDropdown.Item as={Link} to="/human-practices">Human Practices</NavDropdown.Item>                      
              <NavDropdown.Item as={Link} to="/education">Education</NavDropdown.Item>  
              <NavDropdown.Item as={Link} to="/entrepreneurship">Entrepreneurship</NavDropdown.Item>                 
            </NavDropdown>
            <Nav.Link as={Link} to="/Model" className={activeLink ==='Model'?'active navbar-link':'navbar-link' } onClick={() => onUpdateActiveLink('Model')}>Model</Nav.Link>
            <NavDropdown title="Team" id="Team" className={activeLink ==='Team'?'active navbar-link':'navbar-link'}onClick={() => onUpdateActiveLink('HP')}>
              <NavDropdown.Item as={Link} to="/team">Team Member</NavDropdown.Item>                      
              <NavDropdown.Item as={Link} to="/attributions">Attributions</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/collaborations">Collaborations</NavDropdown.Item>      
              <NavDropdown.Item as={Link} to="/communication">Communication</NavDropdown.Item>                     
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

